'use client';

import type { RecentProductItemType } from '@weberus/shared-types';
import { type FC } from 'react';
import { MembershipBadge, StarRating, Thumbnail } from '@yanolja-rnd/nol-design-system';

export interface RecentProductItemProps extends RecentProductItemType {
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

/**
 *  최근 본 상품 - YDM__NOL_RECENT_PRODUCT__V1
 *
 *  @see {@link https://www.figma.com/design/zlHuiOHmYv1ghVDbTHUSvW/%5BGUIDE%5D-%EC%9C%84%EC%A0%AF%2F%EC%98%A4%EB%8D%94%EB%A7%81?node-id=7-6015&t=LKjesAT4c1JcxQYL-1}
 */
export const RecentProductItem: FC<RecentProductItemProps> = ({
  title,
  action,
  imageUrl,
  hasGoldClassBadge,
  score,
  reviewCount,
  description,
  onClick,
}) => {
  return (
    <a
      href={action.web}
      className="block w-68 pc:flex pc:w-[305px] pc:rounded-16 pc:bg-static-white pc:p-16"
      onClick={(e) => onClick?.(e)}>
      <Thumbnail
        alt=""
        image={imageUrl}
        className="pc:mr-16 pc:w-108 pc:shrink-0"
        shape="roundedRectangle_8"
        ratio={{
          mobile: '3_4',
          pc: '1_1',
        }}>
        <div className="absolute left-4 top-4 flex">
          {!!hasGoldClassBadge && (
            <div className="block">
              <MembershipBadge type="gold" />
              &nbsp;
            </div>
          )}
        </div>
      </Thumbnail>
      <div>
        <div className="mt-8 overflow-hidden typography-body-12-regular-line-clamp-1 pc:mt-14 pc:h-44 pc:typography-subtitle-18-regular-line-clamp-2">
          {title}
        </div>
        {/* pc only */}
        <div className="hidden pc:mt-16 pc:flex">
          {!!score && (
            <span className="mr-2">
              <StarRating score={score} size="medium" />
            </span>
          )}
          {!!reviewCount && (
            <>
              {!score && <span className="mr-2 typography-body-14-bold">후기</span>}
              <span className="typography-body-14-regular">{reviewCount}</span>
            </>
          )}
          {!score && !reviewCount && !!description && (
            <p className="text-text-neutral-sub typography-body-14-regular-line-clamp-1">{description}</p>
          )}
        </div>
      </div>
    </a>
  );
};
